import { memo } from 'react'

import { useNavigate } from '@tanstack/react-router'

import { SnackPanelActions, SnackPanelActionsProps, ViewSpace } from '@shared/components/Snackbar'
import { useHotkeys } from '@shared/utils/hooks'
import { SnackPanelActionButtonLink } from 'components/LinkedMUIComponents'
import { avcTaskConfigRoute } from 'pages/NWPlatform/Workspaces/Workspace/AvcTasks/AvcTask'

type SuccessPanelActionsProps = {
  organizationId: string
  environmentId: string
  workspaceId: string
  avcTaskId: string
}

const SuccessPanelActionsRaw = ({
  onClose,
  buttonDefaultProps: _,
  ...routeParams
}: SuccessPanelActionsProps & SnackPanelActionsProps) => {
  const navigate = useNavigate()

  useHotkeys([
    [
      'space',
      () => {
        navigate({ to: avcTaskConfigRoute.to, params: routeParams })
        onClose()
      },
    ],
  ])

  return (
    <SnackPanelActions>
      <SnackPanelActionButtonLink to={avcTaskConfigRoute.to} params={routeParams} onClick={() => onClose()}>
        <ViewSpace />
      </SnackPanelActionButtonLink>
    </SnackPanelActions>
  )
}

export const SuccessPanelActions = memo(SuccessPanelActionsRaw)
